import React from 'react'

export default function DirectMessagingEditorModule({initialState, onDataChanged, props}) {
  return <div>
    <hr/>
    <h5 className="hotspot-setting-header">Direct Messaging</h5>
    <div className="hotspot-setting-info">
      Users will be able to use the global direct messaging, feature in this hotspot.
    </div>

    <div className="hotspot-setting-info">
      A tag owner id, that if set will be the default selected tag owner, for this direct message window
    </div>

    <input
      className="form-control"
      type="text"
      placeholder="Tag Owner Id"
      value={initialState?.preselected_direct_message_tag_owner_id}
      onChange={(event) => {
        onDataChanged({
          ...initialState,
          preselected_direct_message_tag_owner_id: event.target.value
        })
      }}
    />

    <div className="form-group form-check mt-2">
      <input type="checkbox"
             className="form-check-input"
             checked={(initialState?.hide_back_button == "true" || initialState?.hide_back_button == true)}
             onChange={(event) => {
               onDataChanged({
                 ...initialState,
                 hide_back_button: event.target.checked
               })
             }}
      />
      <label htmlFor="" className="form-check-label">
        Disables the back button for this direct message window.
      </label>
    </div>
  </div>
}
